<template>
  <div id="st-container">
    <div id="st-content">
      <button class="close-button" @click="setContentEnabled(false)"></button>
      <component
        :contentEnabled="contentEnabled"
        v-bind:is="currentPageComponent"
        @moveCamTo="moveCamTo"
        @setContentEnabled="setContentEnabled"
        ref="page"
      ></component>
    </div>
  </div>
</template>

<script>
import Iphone12Page from "../pages/Iphone12Page";
import Iphone12ProPage from "../pages/Iphone12ProPage";
import Iphone12MiniPage from "../pages/Iphone12MiniPage";
import Iphone12ProMaxPage from "../pages/Iphone12ProMaxPage";

import IpadAirPage from "../pages/IpadAirPage";
import IpadPage from "../pages/IpadPage";
import Watch6Page from "../pages/Watch6Page";
import WatchSEPage from "../pages/WatchSEPage";

import AddonsPage1 from "../pages/AddonsPage1";
import AddonsPage2 from "../pages/AddonsPage2";
import AddonsPage3 from "../pages/AddonsPage3";
import VideoPage from "../pages/VideoPage";

import Coin1Page from "../pages/coins/Coin1Page";
import Coin2Page from "../pages/coins/Coin2Page";
import Coin3Page from "../pages/coins/Coin3Page";

export default {
  name: "ContentFrame",
  components: {
    Iphone12Page,
    Iphone12ProPage,
    Iphone12MiniPage,
    Iphone12ProMaxPage,
    IpadAirPage,
    IpadPage,
    WatchSEPage,
    Watch6Page,
    AddonsPage1,
    AddonsPage2,
    AddonsPage3,
    Coin1Page,
    Coin2Page,
    Coin3Page,
    VideoPage,
  },
  props: {
    location: String,
    pois: Object,
    isMobile: Boolean,
    contentEnabled: Boolean,
    contentOverride: String,
  },
  data: function () {
    return {
      lastPageComponent: null,
    };
  },

  created() {},
  mounted: function () {
    console.log(this.contentEnabled);
  },
  computed: {
    currentPageComponent: function () {
      if (this.contentOverride) {
        this.lastPageComponent = this.contentOverride;
        return this.contentOverride;
      }

      if (this.pois[this.location].html !== undefined) {
        this.lastPageComponent = this.pois[this.location].html;
        return this.pois[this.location].html;
      }
      return this.lastPageComponent;
    },
  },
  methods: {
    setContentEnabled(enabled) {
      this.$root.playClick();
      this.$emit("setContentEnabled", enabled);
    },
    moveCamTo: function (camData) {
      const camDataClone = Object.assign([], camData);
      if (this.isMobile && this.contentEnabled) {
        camDataClone.fov = camData.fov * 1.5;
        console.log(camDataClone.fov);
      }
      this.$root.comms.send("singtel-goto", camDataClone);

      this.$parent.setCenterRepeat({
        id: this.location,
        camera: camDataClone,
      });
    },
  },
};
</script>

<style scoped></style>
